import {Injectable} from '@angular/core';
import {CsvHandler} from "./csv-handler";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class CsvExporterService {

    generate(DataJSON: any, filename: string, options?: Object) {
       let csv = new CsvHandler(DataJSON, filename, options).generateCsv();
       this.download(csv, filename);
    }

    download(csv: string, filename) {
        //not testable
        let blob = new Blob([csv], {"type": "text/csv;charset=utf8;"});
        filename = filename.replace(/ /g, "_") + ".csv";
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute('visibility', 'hidden');
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName  + EXCEL_EXTENSION);
  }

}
